import { useTranslate } from "@tolgee/react";
import React from "react";
import { Segment, Image } from "semantic-ui-react";
import {
  setGoogleAnalyticsEvent,
  validateEmail,
  validatePhoneNumber,
} from "src/common";

const curYear = new Date().getFullYear();

const FooterLink = ({ text }) => {
  if (validatePhoneNumber(text)) {
    return (
      <a
        href={`tel:${text}`}
        onClick={() => {
          setGoogleAnalyticsEvent({
            action: "portal_dashboard_contact_info_click",
          });
        }}
      >
        {text}
      </a>
    );
  }
  if (validateEmail(text)) {
    return (
      <a
        href={`mailto:${text}`}
        target="_blank"
        onClick={() => {
          setGoogleAnalyticsEvent({
            action: "portal_dashboard_contact_info_click",
          });
        }}
      >
        {text}
      </a>
    );
  }
  return <p>{text}</p>;
};

const Footer = ({ contactInfo }) => {
  const { t } = useTranslate();
  const filterContact = (contact) => {
    return (
      contact.name &&
      contact.name.trim().length &&
      contact.number &&
      contact.number.trim().length
    );
  };

  const filteredContacts =
    contactInfo && contactInfo.length ? contactInfo.filter(filterContact) : [];
  return (
    <Segment as="footer" className="footer-main">
      <div className="footer-container">
        <div className="top-section">
          <div className="footer-segment">
            <Image src="/images/ctm-logo-landscape.png" aria-hidden />
          </div>
          <div className="footer-segment">
            <ul className="ctm-links">
              <li>
                <a
                  href="https://www.travelctm.com/global/privacy"
                  target="_blank"
                >
                  {t({
                    key: "footer.privacyPolicy",
                    defaultValue: "Privacy Policy",
                  })}
                </a>
              </li>
              <li>
                <a
                  href="https://www.travelctm.com/global/terms-and-conditions/"
                  target="_blank"
                >
                  {t({
                    key: "footer.termsConditions",
                    defaultValue: "Terms and Conditions",
                  })}
                </a>
              </li>
            </ul>
          </div>
          {filteredContacts.length > 0 && (
            <div className="footer-segment">
              <h2 id="contacts-list">Contacts</h2>
              <ul className="ctm-links" aria-labelledby="contacts-list">
                {filteredContacts.map((c, i) => {
                  return (
                    <li key={i}>
                      <span className="link-name">{c.name}: </span>{" "}
                      <FooterLink text={c.number} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>

        <p className="copyright">
          {t({
            key: "footer.copyright",
            params: { curYear },
            defaultValue:
              "Copyright {curYear}. Corporate Travel Management is a leading global travel management company, with presence currently throughout Australia & New Zealand, the USA, Asia and Europe.",
          })}
        </p>
      </div>
    </Segment>
  );
};

export default Footer;
